<template>
  <v-container>
    <v-dialog v-model="formulaDialog" max-width="900">
      <formula-generator v-if="formulaDialog" v-bind:formula="dataItem.formula" @save="setFormula" @cancel="closeFormulaDialog"></formula-generator>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="700px">
      <v-form v-model="valid" ref="formData">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{isEdit ? $t('edit') : $t('add')}} {{$t('component')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <label>{{$t('component_type')}}</label>
                  <v-radio-group v-model="dataItem.type" row :rules="rules" required>
                    <v-radio
                      :value="item.id"
                      :label="item.typeName_id"
                      v-for="(item,i) in typeComponent"
                      v-bind:key="i"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-text-field
                    :disabled="isEdit"
                   :label="$t('code')"
                    v-model="dataItem.componentCode"
                    :rules="[...rules3, validator.alfaNumberNotRequired]"
                    max="8"
                    class="sae-required"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-text-field :label="$t('name')" v-model="dataItem.name" :rules="[...rules, validator.requiredComponent]" required class="sae-required"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-textarea
                   :label="$t('formula')"
                    v-model="dataItem.formula"
                    rows="1"
                    auto-grow
                    required
                    append-icon="mdi-function"
                    @click:append="formulaDialog = true"
                    @click="showFormulaDialog"
                    class="sae-required"
                    :rules="rules3a"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pa-0"></v-col>
                <v-col cols="3" class="pt-0 pb-0 mt-0 mb-0">
                  <v-label>{{$t('taxable')}}</v-label>
                </v-col>
                <v-col cols="3" class="pt-0 pb-0 mt-0 mb-0">
                  <v-switch inset color="success" v-model="dataItem.taxable"></v-switch>
                </v-col>
                <v-col cols="6" v-if="dataItem.taxable" class="pt-0 pb-0 mt-0 mb-0">
                  <v-autocomplete
                    :items="taxList"
                    :label="$t('select_tax')"
                    item-text="title"
                    item-value="id"
                    v-model="dataItem.taxParameterId"
                    :rules="rules"
                    class="sae-required"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="pa-0"></v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-select
                  :label="$t('group_by')"
                    :items="groupBPJSList"
                    item-text="name"
                    item-value="id"
                    v-model="dataItem.tab"
                    :rules="rules2"
                    class="sae-required"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="saveOrUpdate(dataItem)"
                :disabled="!valid"
              >{{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{$t('delete_component')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteComponent(dataItem)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col>
        <h2 class="mt-5 mb-6">{{$t('supporting_components')}}</h2>
      </v-col>
    </v-row>

    <v-card>
      <v-tabs
        background-color="white"
        color="primary"
        left
        @change="refreshData($event)"
        class="mb-2"
        v-model="tab"
      >
      <v-tab class="no-justify">BPJS Ketenagakerjaan</v-tab>
        <v-tab class="no-justify">BPJS Kesehatan</v-tab>
        <v-tab class="no-justify">PTKP</v-tab>
        <v-tab class="no-justify">PKP</v-tab>
        <v-tab class="no-justify">Biaya Jabatan</v-tab>
      </v-tabs>

      <v-row class="pa-4">
        <v-col v-if="tab === 0 || tab === 1">
          <v-btn right color="primary" dark class="mb-2" @click="addItem()">{{$t('add_component')}}</v-btn>
        </v-col>
        <v-col md="6">
          <v-text-field
            :rules="[validator.alfaNumberNotRequired]"
            :label="$t('search')"
            prepend-inner-icon="mdi-magnify"
            single-line
            v-model="search"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="i in [0,1,2,3,4]" v-bind:key="i">
          <v-data-table v-if="i === 0 || i === 1"
            :loading="loading"
            :search="search"
            :items="dataListBPJS"
            :headers="headersBPJS"
            :no-data-text="$t('no_data')"
            class="elevation-1 mt-3"
            :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" 
          >
           <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
            <template
              v-slot:item.no="{ item }"
            >{{dataListBPJS.map(function(x) {return x.id; }).indexOf(item.id) + 1}}</template>
              <template v-slot:item.type="{ item }">
                <div>{{$t(item.type)}}</div>
              </template>
            <template v-slot:item.action="{ item }">
              <span>
                <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
                <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
              </span>
            </template>
          </v-data-table>
        <table-component v-else-if="i === 2 || i === 3 || i === 4 " :search="search" :loading="loading" :headers="headers[tab]" :items="dataList"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import TableComponent from './TableComponent.vue'
import FormulaGenerator from './FormulaGenerator.vue';

export default {
  components: {
    TableComponent,
    FormulaGenerator
  },
  name: "config-component",
  data() {
    return {
      validator: this.$store.state.validator,
      tab: 0,
      isEdit: false,
      dialog: false,
      deleteDialog: false,
      typeComponent: [],
      dataList: [],
      dataListBPJS: [],
      taxList: [],
      headers: [
        [],
        [],
        [
          { text: "No", value: "no" },
          { text: this.$i18n.t('code'), value: "status_code" },
          { text: this.$i18n.t('description'), value: "description" },
          { text: this.$i18n.t('amount'), value: "ptkp" },
          { text: this.$i18n.t('start_date'), value: "start_date" },
          { text: this.$i18n.t('end_date'), value: "end_date" },
          // { text: "Action", value: "action" },
        ],
        [
          { text: "No", value: "no" },
          { text: this.$i18n.t('title'), value: "title" },
          { text: this.$i18n.t('with_npwp'), value: "with_npwp" },
          { text: this.$i18n.t('without_npwp'), value: "without_npwp" },
          { text: this.$i18n.t('minimum'), value: "minimum" },
          { text: this.$i18n.t('maximum'), value: "maximum" },
          { text: this.$i18n.t('start_date'), value: "start_date" },
          { text: this.$i18n.t('end_date'), value: "end_date" },
          // { text: "Action", value: "action" },
        ],
        [
          { text: "No", value: "no" },
          { text: this.$i18n.t('type'), value: "deduction_type" },
          { text: this.$i18n.t('percentage'), value: "percentage" },
          { text: this.$i18n.t('minimum'), value: "minimum" },
          { text: this.$i18n.t('maximum'), value: "maximum" },
          { text: this.$i18n.t('start_date'), value: "start_date" },
          { text: this.$i18n.t('end_date'), value: "end_date" },
          // { text: "Action", value: "action" },
        ],
      ],
      search: "",
      editedIndex: -1,
      valid: true,
      rules: [(v) => !!v || this.$i18n.t('required')],
      rules2: [(value) => (value == 0 ? false || this.$i18n.t('required') : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules3: [(v) => !!v || this.$i18n.t('required'), (v) => (v ? v.length <= 5 : false) || 'Max 5 Char'],
      loading: false,
      formulaDialog: false,
      firstLoadFormula: true,
      deleteScheduleTime: false,
     
      headersBPJS: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('code'), value: "componentCode" },
        { text: this.$i18n.t('type'), value: "type" },
        { text: this.$i18n.t('name'), value: "name" },
        { text: this.$i18n.t('formula'), value: "formula" },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      company_id: this.$store.state.company,
      baseUrl: this.$store.state.baseUrl,
      dataItem: {
        id: 0,
        name: "",
        formula: "",
        status: false,
        type: '',
        componentCode: null,
        taxable: false,
        taxParameterId: null
      },
      rules3a: [
        v => /^[+/*\- ()<>%.,0-9a-zA-Z]+$/.test(v) || this.$i18n.t('required_math')
      ],
      groupBPJSList: [
        { id: 1, name: 'BPJS Ketenagakerjaan' },
        { id: 2, name: 'BPJS Kesehatan' },
      ]
    };
  },
  methods: {
    closeFormulaDialog() {
      this.formulaDialog = false
      setTimeout(() => {
        this.firstLoadFormula = true
      }, 1000);
    },
    showFormulaDialog() {
      if (this.firstLoadFormula) {
        this.firstLoadFormula = false
        this.formulaDialog = true
      }
    },
    async getComponent(tab = 0) {
      this.loading = true
      const result = await this.$store.dispatch('getBPJSComponent', { groupBy: parseInt(tab) + 1 })
      this.loading = false
      return result
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      this.loading = true
      const body = { ...data, typeId: data.type, groupBy: data.tab }
      const result = await this.$store.dispatch('saveBPJSComponent', body)
      this.loading = false
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataListBPJS = await this.getComponent(this.tab)
      }
    },
    async editComponent(data) {
      this.loading = true
      const body = { ...data, typeId: data.type }
      const result = await this.$store.dispatch('editBPJSComponent', body)
      this.loading = false
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataListBPJS = await this.getComponent(this.tab)
      }
    },
    async deleteComponent(data) {
      this.loading = true
      const result = await this.$store.dispatch('deletePayrollComponent', data)
      this.loading = false
      if (result == true) {
        this.showMessage('success', 'Data Deleted')
        this.deleteDialog = false
        this.dataList = await this.getComponent(this.tab)
      }
    },
    setFormula(event) {
      this.dataItem.formula = event
      this.formulaDialog = false
      setTimeout(() => {
        this.firstLoadFormula = true
      }, 1000);
    },
    close() {
      this.dialog = false;
    },
    editedItem(item) {
      this.isEdit = true
      this.dataItem = Object.assign({}, item);
      this.dataItem.type = item.typeId
      this.dataItem.tab = item.group_by
      this.firstLoadFormula = true
      this.dialog = true
    },
    deleteItem(item) {
      this.dataItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    costumHeader(action, actionId) {
      return { headers: { action, actionId } }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async getTypeComponent() {
      return await this.$store.dispatch('getPayrollComponentType')
    },
    async getTax() {
      return await this.$store.dispatch('getTax')
    },
    async getData(tab = 0) {
      this.loading = true
      let result 
      switch (tab) {
        case 2:
          result = await this.$store.dispatch('getTaxPTKP')
          break
        case 3:
          result = await this.$store.dispatch('getTaxPKP')
          break
        case 4:
          result = await this.$store.dispatch('getTaxDeduction')
          break
      }
      this.loading = false
      return result
    },
    addItem() {
      this.isEdit = false
      this.dialog = true;
    },
    async refreshData(tab = 1) {
      if(tab === 0 || tab === 1){
        this.dataListBPJS = await this.getComponent(this.tab)
      }else{
      this.dataList = await this.getData(tab)
      }
    }
  },
  async created() {
    this.typeComponent = await this.getTypeComponent()
    this.dataList = await this.getData(this.tab)
    this.taxList = await this.getTax()
    this.dataListBPJS = await this.getComponent(this.tab)
  },
  watch: {
    dialog(show) {
      if (show && !this.isEdit) {
        if (this.$refs.formData) {
          this.$refs.formData.reset();
          this.dataItem = { id: 0, name: "", formula: "", status: false, type: '', componentCode: null, taxable: false, taxParameterId: null }
        }
      }
    },
  },
};
</script>
<style>
.no-justify {
  justify-content: left !important;
}
</style>